import { useFichaCustosTable } from "./use-ficha-custos-table";
import { FichaCustosTableView } from "./view-ficha-custos-table";
import type { FichaCustosTableProps } from "./types-ficha-custos-table";

export function FichaCustosTable(props: FichaCustosTableProps) {
  const vm = useFichaCustosTable(props);

  return <FichaCustosTableView {...vm} />;
}

export type * from "./types-ficha-custos-table";
